module.exports = __webpack_public_path__ + "static/media/work-black.4d72c39f.svg";